(function () {
  if (window.uxBeforeAfterInit) return;
  window.uxBeforeAfterInit = true;

  let dragSlider = null;

  const setPos = (slider, clientX) => {
    const rect = slider.getBoundingClientRect();
    let pos = ((clientX - rect.left) / rect.width) * 100;
    if (pos < 0) pos = 0;
    if (pos > 100) pos = 100;
    slider.style.setProperty('--ba-pos', pos + '%');
  };

  document.addEventListener('pointerdown', (event) => {
    const slider = event.target.closest('.ux-ba__slider');
    if (!slider) return;
    dragSlider = slider;
    if (slider.setPointerCapture) slider.setPointerCapture(event.pointerId);
    setPos(slider, event.clientX);
  });

  document.addEventListener('pointermove', (event) => {
    if (!dragSlider) return;
    setPos(dragSlider, event.clientX);
  });

  document.addEventListener('pointerup', () => { dragSlider = null; });
  document.addEventListener('pointercancel', () => { dragSlider = null; });

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-ba-go]');
    if (!thumb) return;
    const root = thumb.closest('[data-ux-ba]');
    if (!root) return;
    const idx = thumb.getAttribute('data-ba-go');
    root.querySelectorAll('[data-ba-idx]').forEach((el) => {
      el.classList.toggle('is-active', el.getAttribute('data-ba-idx') === idx);
    });
  });
})();
